import React from "react";
import { Link } from "react-router-dom";

const ProfileLinkbar = ({
  handleChangeSection,
  handleLogout,
  editSection,
  paymentSection,
  addressSection,
  ordersSection,
  favoritesSection,
  promotionsSection,
  rewardsSection,
  subSection,
  newsSection,
  unReadNews,
  settingsSection
}) => (
  <div className="white-bg mt-10px link-bar">
    <ul>
      <li>
        <Link
          to="/profile?edit"
          className={(editSection && "active") || ""}
          onClick={() => handleChangeSection("editSection")}
        >
          Profile
        </Link>
      </li>
      <li>
        <Link
          to="/profile?orders"
          className={(ordersSection && "active") || ""}
          onClick={() => handleChangeSection("ordersSection")}
        >
          Orders
        </Link>
      </li>
      <li>
        <Link
          to="/profile?news"
          className={(newsSection && "active") || ""}
          onClick={() => handleChangeSection("newsSection")}
        >
          What{"'"}s New?
          {(unReadNews && <span>{unReadNews}</span>) || <noscript />}
        </Link>
      </li>
      <li>
        <Link
          to="/profile?promotions"
          className={(promotionsSection && "active") || ""}
          onClick={() => handleChangeSection("promotionsSection")}
        >
          Promotions
        </Link>
      </li>
      <li>
        <Link
          to="/profile?addresses"
          className={(addressSection && "active") || ""}
          onClick={() => handleChangeSection("addressSection")}
        >
          Your Addresses
        </Link>
      </li>
      <li>
        <Link
          to="/profile?favorites"
          className={(favoritesSection && "active") || ""}
          onClick={() => handleChangeSection("favoritesSection")}
        >
          Your Favorites
        </Link>
      </li>
      <li>
        <Link
          to="/profile?payments"
          className={(paymentSection && "active") || ""}
          onClick={() => handleChangeSection("paymentSection")}
        >
          Payment Methods
        </Link>
      </li>
      <li>
        <Link
          to="/profile?rewards"
          onClick={() => handleChangeSection("rewardsSection", "points")}
          className="profile-rewards-link"
        >
          Rewards
        </Link>
        {rewardsSection && (
          <>
            <Link
              to="/profile?rewards"
              className={
                (rewardsSection &&
                  (subSection === "points" || !subSection) &&
                  "active profile-rewards-link-item") ||
                "profile-rewards-link-item"
              }
              onClick={() => handleChangeSection("rewardsSection", "points")}
            >
              <p>eCoins</p>
            </Link>
            <Link
              to="/profile?rewards"
              onClick={() => handleChangeSection("rewardsSection", "history")}
              className={
                (rewardsSection &&
                  subSection === "history" &&
                  "active profile-rewards-link-item") ||
                "profile-rewards-link-item"
              }
            >
              <p>History</p>
            </Link>
          </>
        )}
      </li>
      {/* Settings Page */}
      <li>
        <Link
          to="/profile?settings"
          onClick={() => handleChangeSection("settingsSection", "marketing")}
          className="profile-rewards-link"
        >
          Settings
        </Link>

        {settingsSection && (
          <Link
            to="/profile?settings"
            className={
              (settingsSection &&
                (subSection === "marketing" || !subSection) &&
                "active profile-rewards-link-item") ||
              "profile-rewards-link-item"
            }
            onClick={() => handleChangeSection("settingsSection", "marketing")}
          >
            <p>Marketing Settings</p>
          </Link>
        )}
      </li>
      <li className="last">
        <a href="javascript: void(0)" onClick={handleLogout}>
          Log out
        </a>
      </li>
    </ul>
  </div>
);

export default ProfileLinkbar;
